import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { resetRestrictedCountriesStart } from '../../../store/redux-slices/fetchData'
import { createCasinoProviderStart, getAllCasinoProvidersStart, getSuperAdminAggregatorsStart, updateCasinoProviderStart, updateCasinoStatusStart } from '../../../store/redux-slices/superAdminCasinoManagement'
import useDidMountEffect from '../../../utils/useDidMountEffect'

const useProviderListing = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [limit, setLimit] = useState(15)
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)
  const [show, setShow] = useState(false)
  const [providerId, setProviderId] = useState()
  const [status, setStatus] = useState()
  const [statusShow, setStatusShow] = useState(false)
  const [data, setData] = useState()
  const [type, setType] = useState('')
  const [name, setName] = useState()
  const isInitialRender = useDidMountEffect()

  const { casinoProvidersData, aggregators, loading } = useSelector((state) => state.superAdminCasino)
  const totalPages = Math.ceil(casinoProvidersData?.count / limit)

  const handleClose = () => setShow(false)
  const handleShow = (type, data) => {
    setType(type)
    setData(data)
    setShow(true)
  }

  const handleStatusShow = (id, status, myName) => {
    setProviderId(id)
    setStatus(!status)
    setStatusShow(true)
    setName(myName)
  }

  const handleYes = () => {
    dispatch(
      updateCasinoStatusStart({
        data: {
          code: 'CASINO_PROVIDER',
          casinoProviderId: providerId,
          status
        },
        limit,
        pageNo: page,
        search
      })
    )
    setTimeout(() => {
      setStatusShow(false)
    }, 500)
  }

  useEffect(() => {
    dispatch(getAllCasinoProvidersStart({ limit, pageNo: page, search }))
    dispatch(resetRestrictedCountriesStart())
  }, [limit, page])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          dispatch(getAllCasinoProvidersStart({ limit, pageNo: page, search }))
        } else {
          setPage(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  useEffect(() => {
    show && dispatch(getSuperAdminAggregatorsStart({ limit: '', pageNo: '' }))
  }, [show])

  const updateProvider = (data, { casinoProviderId }) =>
    dispatch(
      updateCasinoProviderStart({
        data: {
          ...data,
          casinoProviderId
        },
        limit,
        pageNo: page,
        search
      }))

  const createProvider = (data) =>
    dispatch(
      createCasinoProviderStart({
        data,
        limit,
        pageNo: page,
        search
      })
    )

  return {
    limit,
    setLimit,
    page,
    setPage,
    show,
    statusShow,
    setStatusShow,
    data,
    type,
    casinoProvidersData,
    totalPages,
    handleClose,
    handleShow,
    handleStatusShow,
    handleYes,
    aggregators,
    loading,
    createProvider,
    updateProvider,
    status,
    navigate,
    name,
    search,
    setSearch
  }
}

export default useProviderListing
